export default "__VITE_ASSET__azJXtZ$Q__"